import { render, staticRenderFns } from "./NewStatistics.vue?vue&type=template&id=7a8a0cc5"
import script from "./NewStatistics.vue?vue&type=script&lang=js"
export * from "./NewStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports